<template>
    <div class="content-page" v-if="Admin">
        <!-- Start content -->
        <div class="content">
            <div class="container-fluid">
                <div class="page-title-box">
                    <div class="row align-items-center">
                        <div class="col-sm-6">
                            <h4 class="page-title"><font color="white">VENDOR PROFILE</font></h4>
                        </div>
                    </div>
                </div>
                <!-- end row -->
                <div class="row">
                    <div class="col-12">
                        <div class="card" style="overflow: scroll;">
                            <div class="card-body">
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-sm-2 col-form-label">Vendor Name</label>
                                    <div class="col-sm-10">
                                        <input class="form-control" type="text" v-model="vendor_name" disabled>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="example-text-input" class="col-sm-2 col-form-label">Vendor ID</label>
                                    <div class="col-sm-10">
                                        <input class="form-control" type="text" v-model="vendor_id" disabled>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="example-email-input" class="col-sm-2 col-form-label">Email</label>
                                    <div class="col-sm-10">
                                        <input class="form-control" type="email" v-model="username" disabled>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="example-tel-input" class="col-sm-2 col-form-label">Telephone</label>
                                    <div class="col-sm-10">
                                        <input class="form-control" type="number" v-model="phone" disabled>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="example-number-input" class="col-sm-2 col-form-label">Account Type</label>
                                    <div class="col-sm-10">
                                        <input class="form-control" placeholder="Vendor" disabled>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="example-tel-input" class="col-sm-2 col-form-label">Address</label>
                                    <div class="col-sm-10">
                                        <input class="form-control" type="text" v-model="vendor_address" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                </div>
                <div v-if="spinner" class="text-center">
                    <p>
                        <i class="fa fa-spinner fa-spin fa-3x"></i>
                    </p>
                </div>
              
                <!-- end row -->
                <div v-if="!spinner" class="row">
                    <div class="col-12">
                        <div class="card" style="overflow: scroll;">
                            <div class="card-header mr-5">
                                <h5>Main Bank Account</h5>
                            </div>
                            <div class="card-body">
                                <button type="button" class="btn btn-primary waves-effect waves-light" data-toggle="modal" data-target=".bs-example-modal-center-bank">Change bank account</button>
                 
                                   <table  class="table table-striped table-bordered dt-responsive nowrap text-center" style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                                    <thead>
                                        <tr>
                                        <th>Currency</th>
                                        <th>Bank</th>
                                        <th>Account Details</th>
                                        <th>Account Status</th>       
                                        </tr>
                                    </thead>
                                    <tbody v-if="hasBank">      
                                       <tr>
                                        <td>NGN</td>
                                        <td>{{ bank_name }}</td>
                                        <td>{{account_name}} ({{ bank_account }})</td>
                                        <td>Verified</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                </div>


                <div v-if="!spinner" class="row">
                    <div class="col-12">
                        <div class="card" style="overflow: scroll;">
                            <div class="card-header mr-5">
                                <h5>Branch Bank Account</h5>
                            </div>
                            <div class="card-body">
                                   <table class="table table-striped table-bordered dt-responsive nowrap text-center" style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                                    <thead>
                                        <tr>
                                            <th>Currency</th>
                                            <th>Branch</th>
                                            <th>Bank</th>
                                            <th>Account Details</th>
                                            <th>Account Status</th>       
                                            <th></th>       
                                        </tr>
                                    </thead>
                                    <tbody>      
                                       <tr v-for="branch in branches" :key="branch.branch_id">
                                        <!-- <input type="hidden" name="b_id" value="{{ branch.branch_id }}" id="b_id"> -->
                                        <td>NGN</td>
                                        <td>{{ branch.branch_name }}</td>
                                        <td>{{ branch.bank }}</td>
                                        <td v-if="branch.account_name === ''"></td>
                                        <td v-else>{{branch.account_name}} ({{ branch.account_num }})</td>
                                        
                                        <td v-if="branch.account_name === ''">No Account</td>
                                        <td v-else>Verified</td>
                                        <td>
                                            <button type="button" @click="setBranchId(branch.branch_id, branch.branch_name, branch.account_num)" title="Edit" data-toggle="modal" data-target=".edit-branch-modal">   
                                                <i class="fa fa-edit"></i>
                                            </button>
                                            <button v-if="branch.account_name !== ''" style="margin-left: 10px;" @click="setBranchId(branch.branch_id, branch.branch_name, branch.account_num)" title="Delete" data-toggle="modal" data-target=".delete-branch-modal">
                                                <i class="fa fa-trash" style="color: red;"></i>
                                            </button>
                                        </td>
                                       
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                </div>
            </div>
            <!-- container-fluid -->
        </div>
        <!-- content -->
 <div class="modal fade bs-example-modal-center-bank" id="bank-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title mt-0">Change your NGN settlement account </h5>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
                <div class="modal-body">
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label"> Bank</label>
                        <div class="col-sm-10">
                            <select class="form-control" v-model="code" @change="updateBank(code)">
                                <option value="">Choose bank</option>
                                <option v-for="(bank, index) in banks" :key="index" :value="bank.code">{{ bank.bank }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="example-text-input" class="col-sm-2 col-form-label">Account Number</label>
                        <div class="col-sm-10">
                            <input class="form-control" type="number" v-model="receiver" placeholder="Your business account number">
                        </div>
                    </div>
                    <div class="form-group row"  >
                       <div class="col-sm-4" v-if="!validated">
                            <button type="button" :disabled="validated"  @click="validateAccount()" class="btn btn-primary waves-effect waves-light" > Validate <i v-if="validating" class="fa fa-spinner fa-spin"></i> </button>
                       </div>
                       <div class="col-sm-12 text-success" v-if="validated && !saving">
                           <p><i class="fa fa-check"></i> Account is successfully validated! </p>
                        </div>
                    </div>
                    <div class="form-group row" v-if="validated">
                       
                       <div class="col-sm-8 text-right pr-2">
                           <h6>{{customer_name}}</h6>
                       </div>
                       <div class="col-sm-4" >
                            <button type="button" @click="saveBank()" class="btn btn-primary waves-effect waves-light" v-html="saveButton"></button>
                       </div>
                    </div>
                    
                </div>
                <!-- <input class="form-control" id="showAcctname" placeholder="WILSON" disabled>{{ bank_name}} -->
            </div>
      </div>
            <!-- /.modal-content -->
        </div>

        <div ref="my-modal" class="modal fade edit-branch-modal" id="bank-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title mt-0">Change branch NGN settlement account </h5>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
                <div class="modal-body">
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label"> Bank</label>
                        <div class="col-sm-10">
                            <select ref="field" class="form-control" v-model="code" @change="updateBank(code)">
                                <option value="" selected>Choose bank</option>
                                <option v-for="(bank, index) in banks" :key="index" :value="bank.code">{{ bank.bank }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="example-text-input" class="col-sm-2 col-form-label">Account Number</label>
                        <div class="col-sm-10">
                            <input ref="field" class="form-control" type="number" v-model="receiver" placeholder="Your business account number">
                        </div>
                    </div>
                    <div class="form-group row"  >
                       <div class="col-sm-4" v-if="!validated">
                            <button type="button" :disabled="validated"  @click="validateAccount()" class="btn btn-primary waves-effect waves-light" > Validate <i v-if="validating" class="fa fa-spinner fa-spin"></i> </button>
                       </div>
                       <div class="col-sm-12 text-success" v-if="validated && !saving">
                           <p><i class="fa fa-check"></i> Account is successfully validated! </p>
                        </div>
                    </div>
                    <div class="form-group row" v-if="validated">
                       
                       <div class="col-sm-8 text-right pr-2">
                           <h6>{{customer_name}}</h6>
                       </div>
                       <div class="col-sm-4" >
                            <button :disabled="branch_deleted" type="button" @click="saveBranch()" class="btn btn-primary waves-effect waves-light" v-html="saveButton"></button>
                       </div>
                    </div>
                    
                </div>
                <!-- <input class="form-control" id="showAcctname" placeholder="WILSON" disabled>{{ bank_name}} -->
            </div>
      </div>
            <!-- /.modal-content -->
        </div>

        <div ref="my-modal" class="modal fade delete-branch-modal" id="bank-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0">Delete branch NGN settlement account </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <p>Are you sure you want to delete this branch account?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" v-html="cancel_btn"></button>
                        <button :disabled="branch_deleted"  type="button" @click="deleteBranch()" class="btn btn-primary waves-effect waves-light" v-html="deleteButton"></button>
                    </div>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
    </div>
</template>
<script>
import {setTimeout} from 'timers';
    export default {
        data() {
            return {
                vendor_name: null,
                vendor_id: null,
                banks: [],
                bank_name: '',
                bank_account: '',
                account_name: '',
                code: '',
                vendor_address: '',
                username: '',
                phone: '',
                codename: '',
                receiver: '',
                hasBank: false,
                validated: false,
                validating: false,
                customer_name:'',
                saveButton: `Save <i class="fa fa-save"></i>`,
                deleteButton: `Yes Delete`,
                saving: false,
                level: null,
                Admin: null,
                branches : null,
                branch_id: '',
                branch_name : '',
                branch_acc: '',
                spinner: true,
                branch_deleted: false,
                cancel_btn: 'Cancel',
                branch: '',
            }
        },
        mounted() {
            
            this.level = sessionStorage.getItem("level");
            if(this.level == "admin")
            {
                this.Admin = true;
                this.vendor_name = sessionStorage.getItem("vendor_name");
                this.vendor_id = sessionStorage.getItem("vendor_id");
                this.username = sessionStorage.getItem("username");
                this.phone = sessionStorage.getItem("phone");
                this.vendor_address = sessionStorage.getItem("vendor_address");
                this.viewBank();
                this.retrieveBank();
                this.getBranch();
            }
            else
            {
                this.$router.push('Dashboard');   
            }

             $(this.$refs.my-modal).on('hidden.bs.modal', () => {
                    this.$refs.field.value = null
                });

        },
        watch:{
            role(){
                this.level = sessionStorage.getItem("level");
            if(this.level == "admin")
            {
                this.vendor_name = sessionStorage.getItem("vendor_name");
                this.vendor_id = sessionStorage.getItem("vendor_id");
                this.username = sessionStorage.getItem("username");
                this.phone = sessionStorage.getItem("phone");
                this.vendor_address = sessionStorage.getItem("vendor_address");
                this.viewBank();
                this.retrieveBank();
                this.getBranch();
            }
            else
            {
                this.$router.push('Dashboard');   
            }
            },
            code(){
                //hide save button when code is changed and the save button should be changed to normal
                this.validated = false;
                 this.saveButton = `Save <i class="fa fa-save"></i>`;
                 this.saving = false;
            },
            receiver(){
                //hide the save button when receiver is changed and the save button should be changed to normal
                this.validated = false;
                 this.saveButton = `Save <i class="fa fa-save"></i>`;
                 this.saving = false
            }
        },
        methods: {
           

            setBranchId(branch_id, branch_name, branch_acc)
            {
                this.branch_id = branch_id;
                this.branch_name = branch_name;
                this.branch_acc = branch_acc;
                this.branch_deleted = false;
                this.cancel_btn = 'Cancel';
                this.validated = false;

            },

            

            updateBank(bank) {

                this.codename = bank;
                
            },
            retrieveBank(){
                const app = this;
                

                let user_id = sessionStorage.getItem("userid");

                //Check whether user is logged in
                if( user_id == null){
                    this.$noty.error("Login to Continue.");
                    this.$router.push("login")
                }
                
                var obj = {
                    'action': 'retrieve', 
                    'userid':user_id,
                    'passcode':this.hash(user_id)
                };
                this.axios.post("https://irecharge.com.ng/api/collections/retrieve.php",obj)
                .then(response => {
                   
                    if (response.data.status == "0" ) {
                        this.bank_name = response.data.bank
                        this.bank_account = response.data.receiver
                        this.account_name = response.data.customer_name
                        this.hasBank = true
                    } else {
                        if (response.data.message) {
                            this.$noty.error(response.data.message);
                        }
                    
                    }
                
                }).catch(error => {
                    this.$noty.error("Error occured. Try again");
                });
    
               
            },

            getBranch(){
                $('#bank-modal').modal('hide');

                this.spinner = true;
                let user_id = sessionStorage.getItem("userid");
                let username = sessionStorage.getItem("username");

                var obj = {
                    'action': 'get_branches', 
                    'username': username,
                    'user_id':user_id,
                    'passcode':this.hash(username)
                };

               
                this.axios.post("https://irecharge.com.ng/api/collections/get_branches.php",obj)
                .then(response => {
                    if (response.data.status == "0") {
                        this.branches = response.data.items
                        this.spinner = false;
                    } else {
                        if (response.data.message) {
                            this.$noty.error(response.data.message);
                            this.spinner = false;

                        }
                    
                    }
                
                    }).catch(error => {
                        this.$noty.error("Error occured. Try again");
                    });

                {
            
            }

        },

            saveBranch(){

                this.saving = true

                let selectedBank = "";
                if(this.code != ""){
                    //loop through the banks to get the bank name for the selected bank code
                    for(let i=0; i<this.banks.length; i++){
                        if(this.banks[i].code == this.code){
                            selectedBank = this.banks[i].bank;
                            break;
                        }
                    }
                }
                //Return back if code or receiver are empty
                if(this.code =="" || this.receiver =="" || selectedBank =="" || this.customer_name ==""){
                    this.$noty.error("Input fields cannot be empty!")
                    return;
                }
                //Check if the receiver/Account number is valid
                var acctPattern = /^[0-9]{10}$/i;
                if(!this.receiver.match(acctPattern)){
                    this.$noty.error("Account number is invalid!")
                    return;
                }

                //Check if the user is actually logged in
                let user_id = sessionStorage.getItem("userid");
                let username = sessionStorage.getItem("username");
                let vendor_name = sessionStorage.getItem("vendor_name")

                if(user_id == null || username == null || vendor_name == null){
                    this.$noty.error("Login to continue.");
                    this.$router.push("login")
                }

                var obj = {
                    'action': 'save_branch', 
                    'code': this.code, 
                    'branchid': this.branch_id, 
                    'receiver': this.receiver, 
                    'customer_name': this.customer_name, 
                    'vendor_name': vendor_name, 
                    'bank': selectedBank, 
                    'username': username,
                    'userid':user_id,
                    'passcode':this.hash(this.receiver)
                };

                //changing the saving loader icon
                this.saveButton = `Saving <i class="fa fa-spinner fa-spin"></i>`;

                this.axios.post("https://irecharge.com.ng/api/collections/save_branch.php",obj)
                .then(response => {
                   
                    if (response.data.status && response.data.status == "0" ) {
                        this.customer_name = response.data.customer_name;
                        this.validateButton = `Validated <i class="fa fa-check text-success"></i>`

                        this.retrieveBank();
                        this.getBranch();

                        this.validated = true

                        this.saveButton = `Saved <i class="fa fa-check text-success"></i>`;
                        this.branch_deleted = true;
                        this.$refs['my-modal'].hide()
                        setTimeout( () =>{
                            $('#bank-modal').modal('hide');
                        },1000)

                    } else {
                        this.$noty.error("Account validation failed. Try again.")
                        this.saveButton = `Save <i class="fa fa-save"></i>`;
                    }

                
                }).catch(function(error) {
                    this.$noty.error("Error occured. Try again.");
                      this.saveButton = `Save <i class="fa fa-save"></i>`;
                });

            },

            hash(username) {
                let passcode = "123NDSx";
                let encrypted = CryptoJS.HmacSHA512(username, passcode);
                return encrypted.toString();
            },

            viewBank(){
                const app = this;
                var obj = {
                    'action': 'get_banks',
                };
                obj.passcode = this.hash(obj.action);
                    this.axios.post("https://irecharge.com.ng/api/collections/banks.php",obj)
                    .then(response => {
                        if (response.data.status == "0" ) {
                            this.banks = response.data.banks
                            // this.hasBank = true
                        } else {
                        if (response.data.message) {
                            app.$noty.error(response.data.message);
                        }
                        
                        }
                    
                    }).catch( error => {
                        app.$noty.error("Error occured.");
                    });
    
            },
            validateAccount(){
               //Check if the input fields are not left blank
                if(this.code =="" || this.receiver =="" ){
                    this.$noty.error("Input fields cannot be empty!")
                    return;
                }
                //Check if the receiver/Account number is valid
                var acctPattern = /^[0-9]{10}$/i;
                if(!this.receiver.match(acctPattern)){
                    this.$noty.error("Account number is invalid!")
                    return;
                }

                //Check if this account number is already validated and saved
                if(this.bank_account == this.receiver){
                    this.$noty.warning("This account number has been validated and saved.");
                    return;
                }

                
                var obj = {
                    'action': 'validate', 
                    'receiver':this.receiver,
                    'code': this.code,
                    'passcode':this.hash(this.receiver)
                };
                this.validating = true;
                this.axios.post("https://irecharge.com.ng/api/collections/validate.php",obj)
                .then(response => {
                    
                    if (response.data.status && response.data.status == "0" ) {
                        this.customer_name = response.data.customer_name;

                        this.validated = true
                    } else {
                        this.$noty.error("Account validation failed. Try again.")
                    }
                    this.validating = false;
                
                }).catch( error => {
                    this.$noty.error("Error occured. Try again.");
                    this.validating = false;
                });
    
                
            },

            deleteBranch()
            {
               
                let user_id = sessionStorage.getItem("userid");

                //Check whether user is logged in
                if( user_id == null){
                    this.$noty.error("Login to Continue.");
                    this.$router.push("login")
                }
                
                var obj = {
                    'action': 'delete_branch', 
                    'userid':user_id,
                    'branchid': this.branch_id,
                    'passcode':this.hash(user_id)
                };

                this.deleteButton = `Deleting... <i class="fa fa-spinner fa-spin"></i>`;

                this.axios.post("https://irecharge.com.ng/api/collections/delete_branch.php",obj)
                .then(response => {
                   
                    if (response.data.status == "0" ) {
                        this.getBranch();
                        this.deleteButton = `Deleted <i class="fa fa-check"></i>`;
                        this.cancel_btn = `Close`;

                        this.branch_deleted = true;
                        // this.$noty.su
                    } else {
                        if (response.data.message) {
                            this.$noty.error(response.data.message);
                        }
                    
                    }
                
                }).catch(error => {
                    this.$noty.error("Error occured. Try again");
                });
    


            },
            saveBank(){
                this.saving = true

                let selectedBank = "";
                if(this.code != ""){
                    //loop through the banks to get the bank name for the selected bank code
                    for(let i=0; i<this.banks.length; i++){
                        if(this.banks[i].code == this.code){
                            selectedBank = this.banks[i].bank;
                            break;
                        }
                    }
                }
                //Return back if code or receiver are empty
                if(this.code =="" || this.receiver =="" || selectedBank =="" || this.customer_name ==""){
                    this.$noty.error("Input fields cannot be empty!")
                    return;
                }
                //Check if the receiver/Account number is valid
                var acctPattern = /^[0-9]{10}$/i;
                if(!this.receiver.match(acctPattern)){
                    this.$noty.error("Account number is invalid!")
                    return;
                }

                //Check if the user is actually logged in
                let user_id = sessionStorage.getItem("userid")
                let vendor_name = sessionStorage.getItem("vendor_name")
                let username = sessionStorage.getItem("username");

                if(user_id == null || username == null || vendor_name == null){
                    this.$noty.error("Login to continue.");
                    this.$router.push("login")
                }
                

                var obj = {
                    'action': 'save', 
                    'code': this.code,
                    'receiver': this.receiver,
                    'customer_name': this.customer_name,
                    vendor_name,
                    'userid':user_id,
                    'bank':selectedBank,
                    'passcode':this.hash(this.receiver)
                };
                //changing the saving loader icon
                this.saveButton = `Saving <i class="fa fa-spinner fa-spin"></i>`;

                this.axios.post("https://irecharge.com.ng/api/collections/save.php",obj)
                .then(response => {
                   
                    if (response.data.status && response.data.status == "0" ) {
                        this.customer_name = response.data.customer_name;
                        this.validateButton = `Validated <i class="fa fa-check text-success"></i>`

                        this.retrieveBank();
                        this.validated = true

                        this.saveButton = `Saved <i class="fa fa-check text-success"></i>`;
                        setTimeout( () =>{
                            $('#bank-modal').modal('hide');
                        },1000)
                    } else {
                        this.$noty.error("Account validation failed. Try again.")
                        this.saveButton = `Save <i class="fa fa-save"></i>`;
                    }
                
                }).catch(function(error) {
                    this.$noty.error("Error occured. Try again.");
                      this.saveButton = `Save <i class="fa fa-save"></i>`;
                });
    
                
            },
        },
    }
</script>